import { roles } from '@/modules/auth/roles';
import { hasRole } from '@/modules/auth/utils/hasRoles';
import type { CurrentUserApi } from '@/modules/users/types';

export const TENANT_QUERY_PARAM = 'tenantId';

interface HMTenantSelection {
  canSelectTenant: boolean;
  tenantIds: string[];
  defaultTenantId?: string;
  selectedTenantId?: string;
  tenantParam: string | null;
  tenantSearch: string;
}

export const getHMTenantSelection = (
  currentUser: CurrentUserApi | undefined,
  searchParams: URLSearchParams,
): HMTenantSelection => {
  const tenantIds = currentUser?.tenantIds ?? [];
  const defaultTenantId = currentUser?.defaultTenantId ?? tenantIds[0];
  const userRoles = currentUser?.roles ?? [];
  const isSuperAdmin = hasRole(roles.SuperAdmin, userRoles);
  const canSelectTenant = isSuperAdmin || tenantIds.length > 1;
  const tenantParam = searchParams.get(TENANT_QUERY_PARAM);
  const isTenantParamAllowed =
    tenantParam !== null &&
    (isSuperAdmin || tenantIds.length === 0 || tenantIds.includes(tenantParam));
  const selectedTenantId = canSelectTenant
    ? isTenantParamAllowed
      ? (tenantParam ?? undefined)
      : defaultTenantId
    : defaultTenantId;

  const tenantSearchParams = new URLSearchParams();
  if (canSelectTenant && selectedTenantId) {
    tenantSearchParams.set(TENANT_QUERY_PARAM, selectedTenantId);
  }
  const tenantSearchValue = tenantSearchParams.toString();

  return {
    canSelectTenant,
    tenantIds: isSuperAdmin ? [] : tenantIds,
    defaultTenantId,
    selectedTenantId,
    tenantParam,
    tenantSearch: tenantSearchValue ? `?${tenantSearchValue}` : '',
  };
};
